<script setup lang="ts">
/**
 * Skeleton para cards da Store/Loja
 * Uso: <SmarticoApostatudoSkeletonStoreSkeleton :count="6" />
 */

interface Props {
  /** Quantidade de items skeleton */
  count?: number;
}

withDefaults(defineProps<Props>(), {
  count: 6,
});
</script>

<template>
  <div class="store-skeleton">
    <div
      v-for="n in count"
      :key="`skeleton-${n}`"
      class="skeleton-card"
    >
      <!-- Imagem -->
      <div class="skeleton-image" />
      <!-- Título -->
      <div class="skeleton-title" />
      <!-- Preço -->
      <div class="skeleton-price" />
    </div>
  </div>
</template>

<style scoped lang="postcss">
.store-skeleton {
  @apply grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 items-stretch content-stretch;
}

.skeleton-card {
  @apply flex flex-col gap-2 p-3 rounded-lg;
  background: rgba(255, 255, 255, 0.03);
  min-height: 200px;
}

@media (min-width: 768px) {
  .skeleton-card {
    min-height: 270px;
  }
}

.skeleton-image {
  @apply w-full rounded-lg;
  aspect-ratio: 1 / 1;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.05) 25%,
    rgba(255, 255, 255, 0.1) 50%,
    rgba(255, 255, 255, 0.05) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-title {
  @apply h-4 w-3/4 rounded;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.05) 25%,
    rgba(255, 255, 255, 0.1) 50%,
    rgba(255, 255, 255, 0.05) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-price {
  @apply h-3 w-1/2 rounded;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.05) 25%,
    rgba(255, 255, 255, 0.1) 50%,
    rgba(255, 255, 255, 0.05) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
